import { baseApi } from './baseApi';
import type {
  LoginRequest,
  AuthResponse,
  RegisterRequest,
  RegisterResponse,
} from '../../types/api';

/** RTK Query API – sadece health ve auth (login/register). Diğer entity'ler slice + createAsyncThunk ile yönetiliyor. */
export const smartApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    healthCheck: build.query<void, void>({
      query: () => '/health',
    }),
    login: build.mutation<AuthResponse, LoginRequest>({
      query: (body) => ({
        url: '/api/Auth/login',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Auth'],
    }),
    register: build.mutation<RegisterResponse, RegisterRequest>({
      query: (body) => ({
        url: '/api/Auth/register',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useHealthCheckQuery,
  useLoginMutation,
  useRegisterMutation,
} = smartApi;
